<div
  *ngIf="details"
  class="flex-column preview-details-contianer"
  [ngClass]="{
    'people-preview-large': (!smallWidthPreview && size !== 'popup') || previewPopupLarge
  }"
>
  <div *ngFor="let item of detailsView">
    <div
      *ngIf="details[item]"
      class="flex-row preview-details-wrapper"
      [ngClass]="{ 'preview-details-location': item === 'location', focused: detailsView[this.markedIndex] === item }"
    >
      <div class="preview-details-icon">
        <u-icon [model]="generateIcon(item)" [styles]="{ fontSize: '13.9px' }"></u-icon>
      </div>
      <span
        data-cy="people-preview-detail-item"
        (mousedown)="['email', 'phone'].includes(item) ? copyEmailAndPhone($event,details[item], item) : none"
        [ngClass]="{ 'preview-details-text': true, 'preview-details-text-copy': ['email', 'phone'].includes(item) }"
        [pTooltip]="['email', 'phone'].includes(item) ? generateText(item) : ''"
        tooltipPosition="top"
        tooltipStyleClass="u-tooltip"
      >
        {{ generateText(item) }}
      </span>
    </div>
  </div>
</div>
